import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ApprovalDetailsService } from '../../../Model/ApprovalDetails/approval-details.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-approval-details',
  standalone: true,
  imports: [CommonModule, NgSelectModule, RouterModule, DataTablesModule, FormsModule, LoaderComponent, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './approval-details.component.html',
  styleUrl: './approval-details.component.scss'
})
export class ApprovalDetailsComponent {
  isDisabled: boolean = false;
  ManualPreOnboarding: any = [{ Label: 'Manual', Value: 'AdminWiseManualRegiReport' }, { Label: 'PreOnboarding', Value: 'AdminWisePreOnBoardingReport' }];

  user = [] as any;
  BranchMaster: any[] = [];
  ClientMaster: any[] = [];
  SiteMaster: any[] = [];
  ApprovalData: any[] = []
  Filter = {
    SelectType: 'AdminWiseManualRegiReport',
    UserId: null,
    FromDate: null as any,
    ToDate: null as any,
    FromDateObj: null,
    ToDateObj: null,
    ApprovalStatus: 'All',
    BranchId: null,
    SiteId: null,
    ClientId: null,
    EmpType: null as any,
    EmpCode: null,
    EmpMasterId: null
  }
  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private session: SessionService,
    private router: Router,
    private toast: ToastService,
    private comboload: ComboService,
    private registration: ApprovalDetailsService,
    private dateFormate: CustomDateParserFormatter,
    private download: DownloadSampleService,
    private route: ActivatedRoute
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    //this.TypeData = this.route.snapshot.data['type']; // Will either be 'IDCard' or 'Biodata'
    this.Filter.EmpType = this.router.url.split('/')[3];
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client') ? this.Filter.BranchId : 0,
      'ClientId': (Combotype == 'Site') ? this.Filter.ClientId : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientMaster = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteMaster = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }
  Validate(form: any) {
    if (form.valid) {
      this.Filter.UserId = this.user.UserId
      this.Filter.FromDate = this.dateFormate.format(this.Filter.FromDateObj);
      this.Filter.ToDate = this.dateFormate.format(this.Filter.ToDateObj);
      console.log(this.Filter);
      this.isDisabled = true;
      this.registration.RegistrationDetailsReport(this.Filter).subscribe(
        (data: any) => {
          this.ApprovalData = data.Table;
          if (this.ApprovalData.length > 0) {
            this.download.exportToExcel(this.ApprovalData, 'ApprovalDetails_' + this.Filter.EmpType);
            this.isDisabled = false
          }
          else {
            this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
            this.isDisabled = false
          }
        });  
    }
    else {
      form.submitted = true;
    }
     }

  onSelectChange(type: string) {
    if (type === 'Branch') {
      this.Filter.ClientId = null
      this.ClientMaster = [];
      this.Filter.SiteId = null
      this.SiteMaster = []
    } else if (type === 'Client') {
      this.Filter.SiteId = null
      this.SiteMaster = []
    }
  }
}
